import { render, staticRenderFns } from "./TopicDelete.vue?vue&type=template&id=2e072f19&"
import script from "./TopicDelete.vue?vue&type=script&lang=js&"
export * from "./TopicDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports